import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import numeral from 'numeral'
import moment from 'moment'
import firebase from 'firebase'
import './registerServiceWorker'
import * as VueGoogleMaps from "vue2-google-maps"
import CommonMethods from "@/Mixins/CommonMethods";
import HighchartsVue from "highcharts-vue";


/* eslint-disable */
Vue.config.productionTip = false;
const statuses = require('./assets/static/statuses.json')
const orderTypes = require('./assets/static/orderTypes.json')
Vue.prototype.$status = statuses
Vue.prototype.$orderType = orderTypes


Vue.prototype.$http = Axios;
Vue.prototype.$moment = moment;

const token = localStorage.getItem('token');
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token;
}
Vue.use(HighchartsVue);
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: "places"
    }
});
Vue.use(HighchartsVue);
Vue.mixin(CommonMethods)

Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0");
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
});

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PKR'
    });
    return formatter.format(value).replace('PKR', '').split('.')[0].trim();
});

// Initialize Firebase
let config = {
    apiKey: "AIzaSyDZGFKG78lNemcyXdEXtyKpNFoEvbgnqpw",
    authDomain: "easy-c2d.firebaseapp.com",
    databaseURL: "https://easy-c2d.firebaseio.com",
    projectId: "easy-c2d",
    storageBucket: "easy-c2d.appspot.com",
    messagingSenderId: "641555484341"
};

firebase.initializeApp(config);


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
